// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ColorCrewContact content general snapshot 1`] = `
<div class="contact-color-crew row">
  <div class="xs-12 md-7 md-offset-1">
    <p class="slot-text xs-f-medium lg-f-large max-at-tweak color-slate"></p>
  </div>
  <div class="xs-12 md-3">
    <supportctas-stub hidectas="email" phonenumber="1-123-456-5555" trackeventparams="[object Object]"></supportctas-stub>
  </div>
</div>
`;
